import { j as e } from "../../../jsx-runtime-B6kdoens.js";
import { useContext as s } from "react";
import { c as a } from "../../../index-CROKJrb5.js";
import { c as m } from "../../../create-component-CBAeEoQ6.js";
import { Typography as i } from "../../Typography/index.js";
import { F as l } from "../../../FormControlContext-C7A4R-3o.js";
const n = a({
  base: "cur-mb-1 cur-flex-1 cur-text-meta cur-font-bold",
  variants: {
    disabled: {
      true: "cur-text-disabled",
      false: "cur-text-inherit"
    }
  }
}), d = m(
  "FormControlLabel",
  ({ children: t, ...o }) => {
    const { disabled: r = !1 } = s(l);
    return /* @__PURE__ */ e.jsx(
      i,
      {
        className: n({ disabled: r }),
        weight: "bold",
        size: "meta",
        ...o,
        children: t
      }
    );
  }
);
export {
  d as FormControlLabel
};
//# sourceMappingURL=index.js.map
